import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import LoginForm from "./LoginForm";
import Header from "../../shared/Header";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #2a425e;
  display: flex;
  justify-content: center;
`;

class Login extends Component {
  render() {
    return (
      <Wrapper>
        <Header type="login" />
        <LoginForm
          checkoutlink={
            this.props.location.state && this.props.location.state.link
          }
        />
      </Wrapper>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/components/screens/Login/Login.jsx